import update from 'react-addons-update';
import {
  WORKFLOWS_FETCH_API_FULFILLED,
  WORKFLOWS_CREATE_API_FULFILLED,
  STATES_UPDATE_API_FULFILLED,
} from '../actions';

const initialState = {
  list: [],
  root: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WORKFLOWS_FETCH_API_FULFILLED:
      return update(state, { list: { $set: action.payload }});
    case WORKFLOWS_CREATE_API_FULFILLED:
      return state;
    case STATES_UPDATE_API_FULFILLED: {
      return update(state, { list: { $set: action.payload }});
    }
    default:
      return state;
  }
};
